import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgForm, FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { ShipmentsService } from "../services/shipments.service"
import { AuthService } from '../services/auth.service';
import { AddressesService } from '../services/addresses.service';
import { server } from '../services/constants'

@Component({
  selector: 'app-edit-shipment',
  templateUrl: './edit-shipment.component.html',
  styleUrls: ['./edit-shipment.component.css']
})
export class EditShipmentComponent implements OnInit {  
isLoggedIn$: Observable<boolean>
bolqtid;
loaded = false;
PUDate = "1/1/2017";
DeliverBy;
vwshipment;
altaddresses;
pickupContactid;
pickupContacts;
pickupContact;
delivContacts;
delivContact;
delivContactid;
deliveryLocation;
shipItem;
podState = false;
user;
client;
shipItems;
httpAddress = server;
delivForm: FormGroup;    pickupForm: FormGroup;  pickupContactForm: FormGroup; delivContactForm: FormGroup;
  constructor(private route: ActivatedRoute, 
              private router: Router,
              private shipmentsService: ShipmentsService,
              private authService: AuthService,
              private addressesService: AddressesService) {}

  ngOnInit() {   
    this.authService.getUserClientPromise2() 
    this.isLoggedIn$ = this.authService.isLoggedIn$

    this.authService.user$.subscribe((user:any) => {
      this.user = user;
      this.authService.client$.subscribe((client) => {
        this.client = client;       
      });    
    });

    this.route.params
    .subscribe(
      (params: Params) => {
        this.bolqtid = + params['bol'];
        // load
        this.getVwShipments(this.bolqtid)
      }
    );

        // create Deliv form group
        this.delivForm = new FormGroup({
          delivfname: new FormControl('',[<any>Validators.required]),
          delivlname: new FormControl('',[<any>Validators.required]),
          delivphone: new FormControl('',[<any>Validators.required]),
    
        });
    
        // create Pickup form group
        this.pickupForm = new FormGroup({
          pickupfname: new FormControl('',[<any>Validators.required]),
          pickuplname: new FormControl('',[<any>Validators.required]),
          pickupphone: new FormControl('',[<any>Validators.required]),
    
        });
    
        // create Pickup Contact select form/ single Control
        this.pickupContactForm = new FormGroup({
          selectPickupcontact: new FormControl(([0,<any>Validators.required]))
        });
    
        // create Pickup Contact select form/ single Control
        this.delivContactForm = new FormGroup({
          selectdelivcontact: new FormControl(([0,<any>Validators.required]))
        });
    

    
  }

  getVwShipments(bolqtid){
    // get the bol info from vwshipments from shipments_services
    this.shipmentsService.getVwShipments(bolqtid)
    .then(shipment => {
      this.vwshipment = shipment
      this.vwshipment = this.vwshipment[0];
      this.getShipItems(this.vwshipment.bolqtid)
      this.loaded = true
      // Set POD T/F
      if(this.vwshipment.podname){this.podState = true; console.log(this.podState)}
      this.addressesService.getAltAddresses(this.vwshipment.clientid)
      .then(addresses => {
        this.altaddresses = addresses;
        this.setPickupDelivContacts('pickup');
        this.setPickupDelivContacts('deliv');
      })
    })
  }

  onDelivSave(formValue) {
    console.log(formValue)
    const body = {fname: formValue.delivfname, lname: formValue.delivlname, phone: formValue.delivphone}
    this.addressesService.addAddressContact(body,this.vwshipment.deliveryid)
    .then(result => {
      this.delivContactid = result.insertId
      console.log(result.insertId)
      this.shipmentsService.updateBolqtContact(this.delivContactid, 'deliv', this.bolqtid)
      .then(result => {
      this.getAddressContacts(this.vwshipment.deliveryid)
      .then(contacts => {
          this.delivContacts = contacts;        
          const delivContactArr = this.delivContacts.filter(contact => {return contact.contactid == this.delivContactid})
            this.vwshipment.delivcontact = `${delivContactArr[0].fname} ${delivContactArr[0].lname}`;
            this.vwshipment.delivphone = delivContactArr[0].phone;
            this.vwshipment.deliveryid = delivContactArr[0].contactid;
        });
      });      
    });
  };

  onPickupSave(formValue) {
    const body = {fname: formValue.pickupfname, lname: formValue.pickuplname, phone: formValue.pickupphone}
    this.addressesService.addAddressContact(body,this.vwshipment.pickupid)
    .then(result => {
      this.pickupContactid = result.insertId
      this.shipmentsService.updateBolqtContact(this.pickupContactid, 'pickup', this.bolqtid)
      .then(result => {
        this.getAddressContacts(this.vwshipment.pickupid)
        .then(contacts => {
            this.pickupContacts = contacts;        
            const pickupContactArr = this.pickupContacts.filter(contact => {return contact.contactid == this.pickupContactid})
              this.vwshipment.pucontact = `${pickupContactArr[0].fname} ${pickupContactArr[0].lname}`;
              this.vwshipment.puphone = pickupContactArr[0].phone;
              this.vwshipment.pickupid = pickupContactArr[0].contactid;
        });
      }); 
    })    
  };

  setPickupDelivContacts(type) {
    if(type === 'pickup') {
     this.getAddressContacts(this.vwshipment.pickupid)
      .then(contacts => {
        if(contacts.length > 0) {
          this.pickupContacts = contacts;
          this.pickupContact = this.pickupContacts[0];
          this.pickupContactid = this.pickupContacts[0].contactid;
        }        
      }) 
    }else {
      this.getAddressContacts(this.vwshipment.pickupid)
        .then(contacts => {
          if(contacts.length > 0) {
            this.delivContacts = contacts;
            this.delivContact = this.delivContacts[0];
            this.delivContactid = this.delivContacts[0].contactid;
          }        
        })
    }
    

  };

  onSubmit(form: NgForm) {
    // form submital
    let updateShipment = form.value
    console.log(updateShipment)
    this.shipmentsService.onUpdateBol(updateShipment, this.bolqtid)
    .then(response => {
      if(response){
      let result  = response
      alert('Responce from Database update: ' + result.message)
      this.router.navigate(['/invwithpod'])
    }else {
      alert('Their was an error NOT saved')
    }
    })

   }

   onContactSelect(formvalue, type ) {
    console.log(`${formvalue} Type: ${type} `)
   this.setContactOnSelect(formvalue, type)
  };

  setContactOnSelect(contactid, type) {
    //update tblbolqt then local vwshipment without reload vwshipment from db
    this.shipmentsService.updateBolqtContact(contactid, type, this.bolqtid)
    .then (result => {
      this.addressesService.getAddressContact(contactid)
      .then(rtrnContact => {
        const contact = rtrnContact[0]
        if(type === 'pickup') {
          this.vwshipment.pickupContactid = contactid;
          this.vwshipment.pucontact = `${contact.fname} ${contact.lname}`;
          this.vwshipment.pickupphone = contact.phone;
          this.pickupContactid = contactid;
        }else {
          this.vwshipment.delivContactid = contactid;
          this.vwshipment.delivcontact = `${contact.fname} ${contact.lname}`;
          this.vwshipment.delivphone = contact.phone;
          this.delivContactid = contactid;
        }
      });
      console.log(result)
    })
  };


  onPickupDelivSelected(id, type) {
    // update tblbolqt with change p/u location
    console.log(id)
    this.shipmentsService.changePuDelivId(this.bolqtid, id, type)
    .then(result => {
          this.shipmentsService.getVwShipments(this.bolqtid)
        .then(shipment => {
          this.vwshipment = shipment[0];
          alert(JSON.stringify(result))
          this.getVwShipments(this.bolqtid)
          this.getAddressContacts(this.vwshipment.pickupid)
          .then(contacts => {
            if(contacts.length > 0) {
              this.pickupContacts = contacts;
              this.pickupContact = this.pickupContacts[0];
              this.pickupContactid = this.pickupContacts[0].contactid;
            }        
          })
        })
      })
  }

  onNewAddress() {
    this.router.navigate(['/createaddress/' + this.vwshipment.clientid])
  }

  getAddressContacts(id):Promise<any> {
    // get the contacts for this altAddress
    return this.addressesService.getAddressContacts(id)
    .then(contacts =>  contacts)

  }

  onLoadBol() {
    // load bolqt data in component
    this.shipmentsService.getVwShipments(this.bolqtid)
    .then(shipment => {
      this.vwshipment = shipment[0];
      this.bolqtid = '';
      this.getShipItems(this.vwshipment.bolqtid)
      this.addressesService.getAltAddresses(this.vwshipment.clientid)
      .then(addresses => {
        this.altaddresses = addresses;
      })
    })
  }

  getShipItems(bolqtid) {
    this.shipmentsService.getShipItems(bolqtid)
    .then(shipItems => {
      this.shipItems = shipItems;
    })
    
  }

  onItemSelected(shipitemid) {
    if(shipitemid != 0) {
          // filter array to match bolqtid
        this.shipItem = this.shipItems.filter(function(item) {
          return item.shipitemid == shipitemid;
        });
        console.log(this.shipItem)
      }
    }
  onUpdateShipItem() {
      // update ship item selected
      console.log(this.shipItem[0])
      this.shipmentsService.onUpdateShipItem(this.shipItem[0])
      .then(response => {
        alert(JSON.stringify(response))
      })

    }

}



// WEBPACK FOOTER //
// ./src/app/edit-shipment/edit-shipment.component.ts